import React from "react";
import { Layout } from "components/Layout/Layout";
import { ProjectProvider } from "./context";
import { ProjectPage } from "./ProjectPage";

export const ProjectIndex = () => {
  return (
    <ProjectProvider>
      <Layout>
        <ProjectPage />
      </Layout>
    </ProjectProvider>
  );
};
